// Breakpoints
export const breakpoints = {
  viewport_xxs: 400,
  viewport_xs: 530,
  viewport_sm: 768,
  viewport_md: 992,
  viewport_lg: 1200,
  viewport_xl: 1440,
  viewport_xxl: 1920
};